import http from 'services/http';

/**
 * Re-running the retrievals that stalled attended because headless setup was incomplete when
 * they dispatched (OLIO-3130). The connection row's `stalledRetrievals` is the prompt condition;
 * posting the portal here is the confirmation. The api gates on the same readiness derivation
 * the dispatch uses, so a portal that still can't go headless re-runs nothing.
 */

export interface PortalRedispatchResult {
  workflowId: string;
  actionId: string;
}

export async function redispatchPortalRetrievals(sourceSystem: string) {
  return http
    .post<{ data: PortalRedispatchResult[] }>('portal_redispatches', { sourceSystem })
    .then((res) => res.data.data ?? []);
}
